/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import {
  AchievementType,
  CreateExternalLearningExperienceRequest,
  ExternalLearningExperience,
  LearningExperience,
  UpdateLearningExperienceRequest,
} from '@app/app/page-modules/learning-experiences/learning-experience.model';
import { Page } from '@app/app/shared/models/page';
import { FileUploadPresignedUrlResponseDetailed } from '@app/app/shared/services/file-upload/file-upload.model';
import { FindLerExpInitialResponse } from '@app/app/shared/services/learning-experiences/api-learning-experiences.service';
import { LearningExperiencesService } from '@app/app/shared/services/learning-experiences/learning-experiences.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class MockLearningExperiencesService implements LearningExperiencesService {
  getLearningExperiences(
    achievementType: AchievementType | null,
    term: string | null,
    page: number,
    size: number,
  ): Observable<Page<LearningExperience>> {
    return of({
      content: [],
      totalNumberOfElement: 0,
      pageSize: size,
      currentPageNumber: 0,
    });
  }
  getLearningExperiencesInitialView(size: number): Observable<FindLerExpInitialResponse> {
    return of();
  }
  createExternalLearningExperience(request: CreateExternalLearningExperienceRequest): Observable<ExternalLearningExperience> {
    return of();
  }
  removeLearningExperience(learningExperienceUid: string): Observable<void> {
    return of();
  }
  updateLearningExperience(learningExperienceUid: string, request: UpdateLearningExperienceRequest): Observable<LearningExperience> {
    return of();
  }
  generateAttachmentUploadUrl(attachments: File[]): Observable<FileUploadPresignedUrlResponseDetailed[]> {
    return of();
  }
}
